import type { PrescriptionNodeValue } from 'src/app/shared/models/prescription/prescription-node-value.model';
import type { PrescriptionRequestDto } from 'src/app/shared/models/prescription/prescription-request-dto.model';

import type { IPrescriptionChain } from './prescription-chain';

export class PrescriptionChainHandler implements IPrescriptionChain {
  next = {
    handleRequest(prescriptionDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {
      console.log('All strategies exhausted.');
    },
  };

  setNext(next) {
    this.next = next;
    return next;
  }

  handleRequest(prescriptionDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {}
}
